import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import DefaultDetail from "./DefaultDetail";
export default {
  inject: ['i18n'],
  components: {
    DefaultDetail: DefaultDetail
  },
  props: {
    model: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    categorys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onChange: {
      type: Function,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      categoryCopy: this.categorys
    };
  },
  methods: {
    filterCategory: function filterCategory(input) {
      if (input) {
        this.categoryCopy = this.categorys.filter(function (item) {
          if (!!~item.name.indexOf(input) || !!~item.name.toLowerCase().indexOf(input.toLowerCase())) {
            return true;
          }
        });
      } else {
        this.categoryCopy = this.categorys;
      }
    }
  }
};